<div class="incoming-task-overlay">
  <div class="incoming-task-banner">
    <div class="incoming-info">
      <div class="incoming-info-name">
        <div class="caller-avatar">
          <i [nimbusIcon]="ICONS.USER_LIGHT" [iconWeight]="IconWeight.Regular"></i>
        </div>
        <span class="caller-name">{{ task.caller?.displayName }}</span>
      </div>
      <div class="incoming-info-status">
        <i [nimbusIcon]="modalityIcon" [iconWeight]="IconWeight.Regular" class="incoming-modality-icon"></i>
        <span class="incoming-status-text">
          {{ modalityTitle | translate }}
          {{ task.since | dateDifference: (currentMoment$ | async) | durationFormat: 'mm:ss' }}
        </span>
      </div>
    </div>
    @if (!isAudioTask) {
      <div class="incoming-actions">
        <button class="incoming-action-btn accept" [disabled]="actionInProgress$ | async" (click)="onAccept()">
          <i [nimbusIcon]="ICONS.CHECK" [iconWeight]="IconWeight.Regular"></i>
          <nimbus-tooltip [text]="TranslationKeys.GeneralAccept | translate" [position]="'above'"></nimbus-tooltip>
        </button>
        <button class="incoming-action-btn park" [disabled]="actionInProgress$ | async" (click)="onPark()">
          <i [nimbusIcon]="ICONS.PARK_ROUND" [iconWeight]="IconWeight.Regular"></i>
          <nimbus-tooltip [text]="TranslationKeys.ConversationPark | translate" [position]="'above'"></nimbus-tooltip>
        </button>
        <button class="incoming-action-btn decline" [disabled]="actionInProgress$ | async" (click)="onDecline()">
          <i [nimbusIcon]="ICONS.CLOSE" [iconWeight]="IconWeight.Regular"></i>
          <nimbus-tooltip [text]="TranslationKeys.GeneralReject | translate" [position]="'above'"></nimbus-tooltip>
        </button>
      </div>
    }
  </div>
</div>
